import { type FC } from 'react';
import {
  Container,
  Content,
  InvaliadImage,
  Message,
  Title,
  Wrapper,
} from './style';

const NotFoundPage: FC = () => {
  return (
    <Container>
      <Wrapper>
        <Content>
          <InvaliadImage src={'/img/invalid_page.png'} />
          <Title>요청하신 페이지를 처리할 수 없습니다.</Title>
          <Message>
            서비스 이용에 불편을 드려 죄송합니다.
            <br />
            서비스 이용 중 동일한 현상이 반복될 경우, 관리자 또는 고객센터에
            문의해 주시기 바랍니다.
          </Message>
        </Content>
      </Wrapper>
    </Container>
  );
};

export default NotFoundPage;
